import React from 'react';
import moment from 'moment-timezone';

interface DisplayDateTimeProps {
  dateTime: string;
}

const DisplayDateTime = ({ dateTime }: DisplayDateTimeProps) => {
  return <span>{moment(dateTime).format('D.M.Y H:mm')}</span>;
};

export default DisplayDateTime;
